import ColorInputs from './ColorInputs';

export default ColorInputs;
